import { Directive } from '@angular/core';
import { GtmTrackViewItemListAbstract } from '@df/module-gtm/track/view-item-list/gtm-track-view-item-list.abstract';

/**
 * Directive to track `view_item_list` event.
 * Log this event when the user has been presented with a list of items of a certain category.
 *
 * `gtmTrackViewItemList` is an object with the following properties:
 * - `itemId` (string): The ID of the list in which the item was presented to the user. Example value	`related-products`
 * - `itemName` (string): The name of the list in which the item was presented to the user. Example value	`Related Products`
 * - `models` (Product[]): List of models.
 *
 * @example
 * ```html
 * <a [gtmTrackViewItemList]="gtmTrackViewItemList">...</a>
 * ```
 */
@Directive({
    selector: '[gtmTrackViewItemList]',
    standalone: true
})
export class GtmTrackViewItemListDirective extends GtmTrackViewItemListAbstract {}
